import React from 'react';
import Page from './Page';
import TopBar from './TopBar';

const PopupScreen = ({
  title,
  onBack = () => {},
  children,
  topBarChildren = null,
  fullScreen = false,
  leftIcon = null,
}) => (
  <Page fullScreen={fullScreen}>
    <TopBar title={title} leftIcon={!leftIcon ? 'close' : leftIcon} onLeftIconClick={onBack}>
      {topBarChildren}
    </TopBar>
    {children}
  </Page>
);

export default PopupScreen;
